import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "tab-visibility"
  static values = {
    tabbar: { type: Boolean, default: true },
    navbar: { type: Boolean, default: true }
  }

  connect () {
    super.connect()
    this.send("connect", {
      tabbar: this.tabbarValue,
      navbar: this.navbarValue
    }, () => {})
  }

  disconnect () {
    this.send("disconnect", {
      tabbar: true,
      navbar: true
    }, () => {})
    super.disconnect()
  }
}
